import { CONTROL } from '../../utils/constants';
import { isString } from '../../utils/lang';
export var FALLBACK_PREFIX = 'fallback - ';
var FallbackTreatmentsCalculator = /** @class */ (function () {
    function FallbackTreatmentsCalculator(fallbacks) {
        if (fallbacks === void 0) { fallbacks = {}; }
        this.fallbacks = fallbacks;
    }
    FallbackTreatmentsCalculator.prototype.resolve = function (flagName, label) {
        var _a;
        var treatment = (_a = this.fallbacks.byFlag) === null || _a === void 0 ? void 0 : _a[flagName];
        if (treatment) {
            return this.copyWithLabel(treatment, label);
        }
        if (this.fallbacks.global) {
            return this.copyWithLabel(this.fallbacks.global, label);
        }
        return {
            treatment: CONTROL,
            config: null,
            label: label,
        };
    };
    FallbackTreatmentsCalculator.prototype.copyWithLabel = function (fallback, label) {
        if (isString(fallback)) {
            return {
                treatment: fallback,
                config: null,
                label: "" + FALLBACK_PREFIX + label,
            };
        }
        return {
            treatment: fallback.treatment,
            config: fallback.config,
            label: "" + FALLBACK_PREFIX + label,
        };
    };
    return FallbackTreatmentsCalculator;
}());
export { FallbackTreatmentsCalculator };
